module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "err flexcenter"
  }, [(_vm.buttonKind === 'login') ? _c('div', [(_vm.isEnvironmentPc()) ? _c('div', {
    staticClass: "modal-title"
  }, [_c('p', [_vm._v("再度サインインしてください。")]), _vm._v(" "), _c('p', [_vm._v("改善しない場合は、"), _c('a', {
    attrs: {
      "href": "https://www.sourcenext.com/support/qa/?faq=RS-09396",
      "target": "_blank"
    }
  }, [_vm._v("サポートページ")]), _vm._v("をご覧ください。")])]) : _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("再度サインインしてください")])]) : _c('div', [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), (_vm.buttonKind === 'login') ? _c('div', {
    staticClass: "align-center"
  }, [_c('button', {
    staticClass: "login",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("サインインする")])]) : (_vm.buttonKind === 'serial') ? _c('div', {
    staticClass: "align-center"
  }, [_c('button', {
    staticClass: "serial",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goSerial
    }
  }, [_vm._v("シリアル入力画面")])]) : (_vm.buttonKind === 'library') ? _c('div', {
    staticClass: "align-center"
  }, [_c('button', {
    staticClass: "serial",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goLibrary
    }
  }, [_vm._v("ライブラリへ戻る")])]) : (_vm.buttonKind === 'close') ? _c('div', {
    staticClass: "align-center"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("閉じる")])]) : _c('div', {
    staticClass: "flexbox"
  }, [_c('button', {
    staticClass: "retry",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("再実行")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("キャンセル")])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f1662c1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-2f1662c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 861
// module chunks = 1